import React, { useEffect, useState } from 'react';
import Nav from '../components/Nav';
import { Link } from 'react-router-dom';
import ApiService from '../services/ApiService';
import getActiveSubscription from '../services/getActiveSubscription'; 

const PricingPage = () => {

    const [subscriptions, setSubscriptions] = useState([]);
    const [activeSubscriptions, setActiveSubscriptions] = useState([]);

    const getSubscriptions = async () => {
        try {
            const response = await ApiService.get(`/cms/subscriptions?status=true`);

            if (response?.contents?.length > 0) {
                setSubscriptions(response?.contents);
            } else {
                setSubscriptions([]);
            }
        } catch (err) {
            console.error("Error during fetching subscriptions data:", err);
        }
    };

    const getSubscriptionsID = async () => {
        const orders = await getActiveSubscription();
        setActiveSubscriptions(orders)
    }

    useEffect(() => {
        getSubscriptions();
        getSubscriptionsID();
    }, []);

    const frequency = (value) => {
        switch (value) {
            case "weekly":
                return 'we';
            case "monthly":
                return 'mo';
            case "semiannual":
                return 'sa';
            case "annual":
                return 'yr';
            default:
                return '';
        }
    };


    return (
        <div className="tyn-root dashboard">
            <Nav />
            <div className="tyn-content tyn-content-page">
                <div className="tyn-main">
                    <div className="tyn-section tyn-section-lg pb-0">
                        <div className="container">
                            <div className="tyn-section-head tyn-text-block text-center">
                                <h2 className="h1 text-white">Try for free, no credit card</h2>
                                <p className='text-white'>Billing: Save with annual subscription.</p>
                            </div>
                            <div className="tyn-section-content">
                                <div className="row g-4 justify-content-center">
                                    {subscriptions?.map((plan, index) => {
                                        const isLastOdd = subscriptions.length % 2 !== 0 && index === subscriptions.length - 1;
                                        const colClass = isLastOdd
                                            ? "col-xl-3 col-lg-4"
                                            : "col-xl-3 col-lg-4 col-sm-6";

                                        return (
                                            <div key={plan._id} className={colClass}>
                                                <div className="card h-100 border-0">
                                                    <div className="card-body p-4 d-flex flex-column justify-content-between">
                                                        <div>
                                                            <div className="text-muted text-opacity-50 fs-7 mt-n2 fw-medium">Popular</div>

                                                            <div className="h1 text-primary">
                                                                ${plan?.data?.total}
                                                                <small className="fs-5">/{frequency(plan?.data?.type)}</small>
                                                            </div>
                                                            <h5 className="pb-2 pt-1">{plan?.data?.name}</h5>

                                                            <h6 className="pb-2 pt-1 text-capitalize">
                                                                {plan?.data?.type} subscription
                                                            </h6>

                                                            <ul className="list-check fs-6 d-flex flex-column gap gap-2">
                                                                {plan?.data?.features?.map((feature, featureIndex) => (
                                                                    <li key={featureIndex} className="d-flex gap gap-2">
                                                                        <span className="text-success">
                                                                            <svg
                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                                width="16"
                                                                                height="16"
                                                                                fill="currentColor"
                                                                                className="bi bi-check"
                                                                                viewBox="0 0 16 16"
                                                                            >
                                                                                <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425z" />
                                                                            </svg>
                                                                        </span>
                                                                        <span className="text-capitalize">{feature}</span>
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        </div>
                                                        <div className="mt-4">

                                                        {
                                                            activeSubscriptions?.includes(plan?._id) && ( <span className="btn btn-light disabled">Current Plan</span>) || ( <Link to={`/checkout/${plan?._id}`} className="btn btn-primary">
                                                                Upgrade Now
                                                            </Link>)
                                                        }
                                                           
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PricingPage;
